// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"0ed4b726","453":"b48e2ba1","703":"4ca21a85"}[chunkId] + ".chunk.js";
};